import omit from "lodash.omit"
import { StyleProps, styled, CSSFn, callCSSFn } from "../../styles"
import { getCardCss } from "../../Card"
import { Variant } from "../variant.type"

export interface StyledMessageProps {
  variant?: Variant
  css?: CSSFn
}

type Props = StyledMessageProps & StyleProps

const StyledMessage = styled.div<StyledMessageProps>((props: Props) => ({
  ...getCardCss(omit(props, `css`)),
  borderTopWidth: 8,
  borderTopStyle: `solid`,
  maxWidth: 450,
  borderColor: props.variant === `error` ? props.theme.palette.error : props.theme.palette.brand,
  ...callCSSFn(props),
}))

StyledMessage.defaultProps = {
  variant: `info`,
}
export default StyledMessage
